import * as Yup from 'yup'

export const schema = Yup.object().shape({
  appPassword: Yup.string()
    .min(16, 'App Password should have 16 symbols')
    .max(16, 'App Password should have 16 symbols')
    .required('App Password is required')
    .nullable()
})
